<template>
<div class="full">
    <div class="mainSection">
        <div class="text" style="margin: 0 0 0 0;">
            <!-- <p>중랑구 시설관리 공단은 언제나</p> -->
            <p>광명도시공사는 언제나</p>
            <p>시민여러분의 의견을 기다립니다.</p>
        </div>

        <div class="section">
            
            <el-tabs id="tabs" ref="tabs" type="card" @tab-click="handleClick"> 

                <el-button ref="btn" class="button" type="text" @click="goPath">more</el-button>
                
                <!-- &#43; -->

                <el-tab-pane v-for="(item, index) in title" :key="index" :label="item.path">
                    <el-table :data="tableArray" :total="5" :show-header="false" 
                    empty-text="등록된 정보가 없습니다."  @cell-click="goBoardInfo" >
                        <el-table-column id="title" :show-overflow-tooltip="true" prop="title" align="center">
                        </el-table-column>
                        <el-table-column id="insertDate" prop="insertDate" align="center">
                        </el-table-column>
                    </el-table>
                </el-tab-pane>

            </el-tabs>

            <!-- 4개의 주 사용버튼 -->  
            <div id="box" class="box">
                <el-row class="box1">
                    <router-link :to="{ name: '요금안내' }">
                        <div class="checkBox1">
                            <!-- <el-button id="carCoin" class="left">주차요금 안내</el-button> -->
                            <el-button id="carTime" class="left"></el-button>
                        </div>
                    </router-link>

                    <!-- <div class="checkBox2">
                        <router-link :to="{ name: '미납주차 요금안내' }">
                            <el-button id="top" class="right" @click="submitActive">미납요금안내</el-button>
                        </router-link>
                    </div> -->
                    <router-link :to="{ name: '노상주차장 현황' }">
                    <div class="checkBox2">
                        <!-- <el-button id="carOut" class="right" @click="submitActive">시설현황</el-button> -->
                        <el-button id="carOut" class="right" @click="submitActive"></el-button>
                    </div>
                    </router-link>
                </el-row>

                <el-row class="box2">
                    <router-link :to="{name: '안내사항'}">
                    <div class="checkBox3">
                        <el-button id="carTime" class="left"></el-button>
                        <!-- <el-button id="carTime" class="left">실시간 주차 현황</el-button> -->
                    </div>
                    </router-link>

                    <router-link :to="{ name: '차량변경/환불요청' }">
                        <div class="checkBox4">
                            <el-button id="question" class="right"></el-button>
                        </div>
                    </router-link>

                </el-row>
            </div>
            
        </div>
       
    </div>

    <!-- 모바일 전용 tab -->
    <!-- <div class="mobileTab">
        <el-tabs id="mobileNoticeTab" class="mobileNoticeTab" ref="tabs"> 

            <el-tab-pane v-for="(item, index) in mobileTitle1" :key="index" :label="item.path">
                <el-table :data="firstMobileArray" :total="5" :show-header="false" 
                empty-text="등록된 정보가 없습니다."  @cell-click="goBoardInfo" >
                    <el-table-column id="title" prop="title" align="center">
                    </el-table-column>
                    <el-table-column id="insertDate" prop="insertDate" align="center">
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-button ref="btn" class="mobileTabButton" type="text" @click="goPath">더보기+</el-button>

        </el-tabs>

        <el-tabs id="mobileEachTab" class="mobileEachTab" ref="tabs" @tab-click="secondMobileArrayClick"> 

            <el-tab-pane v-for="(item, index) in mobileTitle2" :key="index" :label="item.path">
                <el-table :data="secondMobileArray" :total="5" :show-header="false" 
                empty-text="등록된 정보가 없습니다." @cell-click="goBoardInfo" >
                    <el-table-column id="title" prop="title" align="center">
                    </el-table-column>
                    <el-table-column id="insertDate" prop="insertDate" align="center">
                    </el-table-column>
                </el-table>
            </el-tab-pane>

            <el-button ref="btn" class="mobileTabButton" type="text" @click="goPath">더보기+</el-button>

        </el-tabs>

    </div> -->

    <div class="mobileTabs">

        <div class="mobileTabs1">
            <div class="mobileTabsBtn">
                <el-button class="noticeBtn" type="text">공지사항</el-button>
            </div>

            <hr class="tabLine1" />
            <el-table class="tabTable1" :data="firstMobileArray"
            empty-text="등록된 것이 없습니다."  style="width:340px; height: 240px"
            @cell-click="goTableInfo">
                <el-table-column prop="title" :show-overflow-tooltip="true" width="auto"/>
                <el-table-column prop="insertDate" width="100px"/>
            </el-table>

            <el-button type="text" id="more" class="more" @click="moreNotice">더보기 + </el-button>

        </div>

        <div class="mobileTabs2">
            <div class="mobileTabsBtn">
                <el-button id="faqButton" class="eachBtn" type="text"
                :class="{ active: this.isFaq }">
                    자주하는 질문
                </el-button>
                <el-button id="qnaButton" class="eachBtn" type="text"
                :class="{ active: this.isQna }">
                    차량변경/환불요청
                </el-button>
            </div>

            <hr class="tabLine1" />
            <el-table class="tabTable2" :data="secondMobileArray"
            empty-text="등록된 것이 없습니다." style="width:340px; height: 240px"
            @cell-click="goTableInfo">
                <el-table-column prop="title" :show-overflow-tooltip="true" width="auto"/>
                <el-table-column prop="insertDate" width="100px"/>
            </el-table>

            <el-button type="text" id="more" class="more" @click="morePath">더보기 + </el-button>
        </div>

        </div>

    <MainFooter class="footer"/>
</div>
</template>

<script>
import MainFooter from '../basic/mainFooter.vue';
import build from '@/api/example';

export default {
    data() {
        return {
            idx: 0,
            name: "공지 사항",
            mobileIdx: 0,
            mobileName: "자주하는 질문",
            tableArray: [],
            title :[
                {id: 0, path: '공지 사항'},
                {id: 1, path: '자주하는 질문'},
                {id: 2, path: '차량변경/환불요청'}
            ],
            mobileTitle1: [
                {id: 0, path: '공지 사항'}
            ],
            mobileTitle2: [
                {id: 1, path: '자주하는 질문'},
                {id: 2, path: '차량변경/환불요청'}
            ],
            startEvent: false,
            moveEvent: false,
            mobileTouch: true,
            checkMobile: false,
            firstMobileArray:[],
            secondMobileArray:[],
            isFaq: true,
            isQna: false,
            titleMenu: "FAQ",
            titleNotice: "Notice"
        }
    },
    methods: {
        firstTab(){

            build.get('/api/boardNotice/main')
            .then(res => {
                this.tableArray = res.data;
                console.log(this.tableArray);

            }).catch(err => {
                console.log(err);
            })
        },
        handleClick(tab) {

            this.idx = tab.index;
            this.name = tab.label;

            if(this.idx == 0) {

                this.tableArray = []
                build.get('/api/boardNotice/main')
                .then(res => {
                    this.tableArray = res.data;
                    console.log(this.tableArray);

                }).catch(err => {
                    console.log(err);
                })
            } 
            else if(this.idx == 1) {
                
                this.tableArray = []

                build.get('/api/boardFaq/main')
                .then(res => {
                    this.tableArray = res.data;
                    console.log(this.tableArray);

                }).catch(err => {
                    console.log(err);
                })
            }
            else if(this.idx == 2) {

                this.tableArray = []

                build.get('/api/boardRequest/tabTable')
                .then(res => {
                    this.tableArray = res.data;
                    console.log(this.tableArray);

                }).catch(err => {
                    console.log(err);
                })
            }
            

        },
        firstMobileArrayClick() {

            // console.log("first")

            build.get('/api/boardNotice/main')
            .then(res => {
                this.firstMobileArray = res.data;
                console.log(this.tableArray);

            }).catch(err => {
                console.log(err);
            })

            build.get('/api/boardFaq/main')
                .then(res => {
                    this.secondMobileArray = res.data;

                    console.log(this.secondMobileArray);

                }).catch(err => {
                    console.log(err);
                })

        },
        isMobile() {
            var user = navigator.userAgent;

            // console.log(user)

            if( user.indexOf("iPhone") > -1 
                || user.indexOf("Android") > -1 
                || user.indexOf("iPad") > -1
                || user.indexOf("iPod") > -1
            ) {
                this.checkMobile = true;
            }
        },
        secondMobileArrayClick() {

            const faqButton = document.getElementById("faqButton");
            const qnaButton = document.getElementById("qnaButton");

            faqButton.addEventListener('click', () => {

                build.get('/api/boardFaq/main')
                .then(res => {
                    this.secondMobileArray = res.data;
                    console.log(this.secondMobileArray);

                }).catch(err => {
                    console.log(err);
                })

            })

            qnaButton.addEventListener('click', () => {
                build.get('/api/boardRequest/tabTable')
                .then(res => {
                    this.secondMobileArray = res.data;
                    console.log(this.secondMobileArray);

                }).catch(err => {
                    console.log(err);
                })
            })

            document.addEventListener('touchstart', (e) => {
                e.preventDefault();
                // e.stopPropagation(); 

                this.startEvent = true;
            },{passive: false});

            document.addEventListener('touchmove', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                if(!this.startEvent) {
                    return;
                }
                this.moveEvent = true

            },{passive: false});

            faqButton.addEventListener('touchend', (ev) => {
                ev.preventDefault();

                build.get('/api/boardFaq/main')
                .then(res => {
                    this.secondMobileArray = res.data;
                    console.log(this.secondMobileArray);

                }).catch(err => {
                    console.log(err);
                })

            })

            qnaButton.addEventListener('touchend', (ev) => {
                ev.preventDefault();
                
                build.get('/api/boardRequest/tabTable')
                .then(res => {
                    this.secondMobileArray = res.data;
                    console.log(this.secondMobileArray);

                }).catch(err => {
                    console.log(err);
                })

            })

        },
        goPath() {
            this.$router.push({name : this.name })
        },
        submitActive() {
            this.$store.isActive = true
            this.$store.isSubmit = false
        },
        goBoardInfo(ev) {

            if(this.idx == 0) {
                
                this.$router.push({ name: '공지 사항 내용', params: { id: ev.id }});
                this.updateLookNum(this.id);
            } else if (this.idx == 1) {

                this.$router.push({ name: '자주하는 질문 내용', params: { id: ev.id }});
                this.updateLookNum(this.id);

            } 
            else if (this.idx == 2) {

                this.$router.push({ name: '차량변경/환불신청 내용', params: { id: ev.id }});
                // this.updateLookNum(this.id);

            }
        },
        updateLookNum(id) {

            build.post('/api/boardFaq/updateLook',{ id : id })
            .then(res => {
                console.log(res);
            }).catch(err => {
                console.log(err);
            })
        },
        checkFaq() {

            const faqButton = document.getElementById("faqButton");

            document.addEventListener('touchstart', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                this.startEvent = true;
            },{passive: false});

            document.addEventListener('touchmove', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                if(!this.startEvent) {
                    return;
                }
                this.moveEvent = true
                
            },{passive: false});

            /* click */
            faqButton.addEventListener('click', () => {

                this.titleMenu = "FAQ";

                this.isFaq = true;
                this.isQna = false;

            })

            faqButton.addEventListener('touchend', (ev) => {
                ev.preventDefault();

                this.titleMenu = "FAQ";

                this.isFaq = true;
                this.isQna = false;

            }, false)
        },
        checkQna() {
            
            const qnaButton = document.getElementById("qnaButton");

            document.addEventListener('touchstart', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                this.startEvent = true;
            },{passive: false});

            document.addEventListener('touchmove', (e) => {
                e.preventDefault();
                // e.stopPropagation();

                if(!this.startEvent) {
                    return;
                }
                this.moveEvent = true
                
            },{passive: false});

            /* click */
            qnaButton.addEventListener('click', () => {

                this.titleMenu = "QNA";

                this.isFaq = false;
                this.isQna = true;

            })

            qnaButton.addEventListener('touchend', (ev) => {
                ev.preventDefault();

                this.titleMenu = "QNA";

                this.isFaq = false;
                this.isQna = true;

            }, false)
        },
        goTableInfo(ev) {

            console.log('ev.state', ev.state);

            if(ev.state == "FAQ") {

                this.$router.push({ name: '자주하는 질문 내용', params: { id: ev.id }})
                this.updateLookNum(ev.id);

            } else if(ev.state == "QNA") {

                this.titleMenu = ev.state;

                this.$router.push({ name: '차량변경/환불신청 내용', params: { id: ev.id }});

            } else if (ev.state == "Notice") {

                this.$router.push({ name: '공지 사항 내용', params: { id: ev.id }});
                this.updateLookNum(ev.id);

            }
        },
        morePath() {

            if(this.titleMenu == "FAQ") {

                this.$router.push({name : '자주하는 질문' })

            } else if(this.titleMenu == "QNA") {

                this.$router.push({name : '차량변경/환불요청' })
            }

        },
        moreNotice() {

            this.$router.push({name : '공지 사항' })
            
        }
    },
    mounted() {

        this.checkFaq();
        this.checkQna();

        this.isMobile();

        const scrollBar = this.$refs.tabs.$el.querySelector(".el-tabs__nav-scroll");
        scrollBar.appendChild(this.$refs.btn.$el);

        this.firstTab();

        this.firstMobileArrayClick();
        this.secondMobileArrayClick();

        window.addEventListener('touchmove', () => {
            this.mobileTouch = false;
        });

        window.addEventListener('touchstart', () => {
            this.mobileTouch = true;
        });

        window.addEventListener('touchcancel', () => {
            this.mobileTouch = true;
        });

        window.addEventListener('touchend', () => {
            this.mobileTouch = true;
        });

    },
    unmounted() {

        window.removeEventListener('touchmove', () => {});
        window.removeEventListener('touchstart', () => {});
        window.removeEventListener('touchcancel', () => {});
        window.removeEventListener('touchend', () => {});

    },
    components: { 
        MainFooter
    }
}

</script>

<style scoped>
@import '@/assets/css/reset.css';

    .mobileTabs {
        display: none;
    }

    .full {
        height: 100vh;
        margin: auto;
        padding-bottom: 3%;
    }
    .mainSection {
        margin: auto;
        margin-top: 200px;
        text-align: center;
        width: 1200px !important;
        height: auto;
    }
    .button {
        float: right;
        border: none;
        width: 24px;
        height: 24px;
        text-align: center;
        font: normal normal 500 15px/26px Noto Sans KR;
        letter-spacing: -0.5px;
        margin-right: 3%;
        color: #838383;
        padding-top: 2% !important;
    }
    .text {
        float: right;
        margin-bottom: 10vh !important;
        text-align: center;
        font: normal normal 500 36px/52px Noto Sans KR;
        letter-spacing: 0px;
        color: #000000;
    }
    
    p {
        margin: 0;
        width: 1200px;
    }

    .el-table >>> .el-table__cell {
        padding-top: 1vh;
        padding-bottom: 1vh;
    }


    .el-table >>> .cell {
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden; 
    }

    #tabs >>> .el-tabs__nav-scroll {
        display: flex !important;
        justify-content: space-between !important;
        margin-bottom: 0.4%;
    }
    
    /* tabs-header css */
    #tabs >>> .el-tabs__header {
        border-bottom: 2px solid #3287C3;
        margin-bottom: 0 !important;
    }

    #tabs >>> .el-tabs__content {
        background: rgb(255, 255, 255);
        /* height: 330px; */
    }

    #tabs >>> .el-tabs__item {
        height: 50px;
        background: #FFFFFF;
    }

    #tabs >>>.el-tabs__header .el-tabs__item {
        padding-top: 5px;
        text-align: center;
        font: normal normal 500 20px/39px Noto Sans KR;
        letter-spacing: -0.5px;
        color: #838383;
    }

    #tabs >>> .el-tabs__header .el-tabs__item.is-active {
        text-align: center;
        font: normal normal 20px/39px Noto Sans KR-BOLD;
        color: #FFFFFF;
        background: #3287C3 0% 0% no-repeat padding-box;
    }

    #tabs >>> .cell {
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden; 
        text-align: left;
        margin-left: 8%;
        font: normal normal normal 15px/29px Noto Sans KR;
        letter-spacing: 0px;
        color: #5A5B5E;
        cursor: pointer;
    }

    /* table shadow 없앰 */
    #tabs >>> .el-table__fixed,
    #tabs >>> .el-table__fixed-right {
        box-shadow: none;
    }

    /* table CSS */
    #tabs {
        margin-left: 3%;
        float: left;
        width: 48%;
        height: auto;
        text-align: center;
    }

    #tabs >>> .el-table__empty-text {
        font: normal normal normal 15px/29px Noto Sans KR;
    }

    /* 버튼 CSS */
    #box {
        width: 45.9%;
        height: 85%;
        float: left;
        margin-left: 2%;
        padding-bottom: 3vh;
    }

    .el-row {
        margin: auto;
    }

    .el-row >>> .el-button {
        height: 100%;
        /* width: 40%; */
        padding: 36% 13% 22% 13%;
        text-align: center;
        font: normal normal 28px/40px Noto Sans KR-BOLD;
        letter-spacing: -0.7px;
        color: #FFFFFF;
        background-color: transparent;
        border-color: transparent;
    }

    /* button css */
    .box2 {
        margin-top: 0.5%;
    }
    .checkBox1 {
        width: 49%;
        height: 100%;
        display: inline-block;
        background: transparent url('@/components/image/icon_price.png') 0% 0% no-repeat padding-box;
        background-size: contain;
    }

    .checkBox2 {
        width: 49%;
        height: 100%;
        display: inline-block;
        background: transparent url('@/components/image/icon_facilities.png') 0% 0% no-repeat padding-box;
        background-size: contain;
    }

    .checkBox3 {
        width: 49%;
        height: 100%;
        display: inline-block;
        background: transparent url('@/components/image/icon_location.png') 0% 0% no-repeat padding-box;
        background-size: contain;
    }

    .checkBox4 {
        width: 49%;
        height: 100%;
        display: inline-block;
        background: transparent url('@/components/image/그룹 18689.png') 0% 0% no-repeat padding-box;
        background-size: contain;
    }

    .footer {
        width: 100%;
        height: auto;
        /* float: left; */
        position: static;
        /* bottom: 0 !important; */
        display: inline-block;
        padding-top: 3%;
    }

    /* 반응형 웹 CSS */
   
    @media all and (max-width: 1200px) {
        
        .full {
            width: 100vw;
            margin: 0;
            display: inline-block;
        }
        .section {
            margin-right: 0;
            margin-left: 2%;
        }

        .text {
            margin-top: 2vh !important;
            margin-bottom: 8vh !important;
        }

        #tabs {
            margin-left: 0.5%;
        }

        .footer {
            padding-top: 5vh;
        }
    }
    
    @media all and (max-width: 1024px) {

        #box {
            margin-left: 0;
            width: 54vw;
            margin-top: 4vh;
        }

        #tabs {
            margin-left: 0.5%;
            width: 35%;
            margin-top: 4vh;
        }

        .full {
            width: 100vw;
            margin: 0;
            display: inline-block;
        }
        
        .text {
            margin: 0 0 4vh 0 !important;
            width: 100vw;
            float: left;
        }

        .box2 {
            margin-top: 0.5vh;
        }

        p {
            width: 100vw;
            margin-bottom: 1%;
        }

        .el-row >>> .el-button {
            padding: 30% 3vw 13% 3vw;
        }

        .checkBox1 {
            width: 26vw;
            padding-top: 2vh;
            padding-bottom: 2vh;
        }
        .checkBox2 {
            width: 26vw;
            padding-top: 2vh;
            padding-bottom: 2vh;
        }
        .checkBox3 {
            width: 26vw;
            padding-top: 2vh;
            padding-bottom: 2vh;
        }
        .checkBox4 {
            width: 26vw;
            padding-top: 2vh;
            padding-bottom: 2vh;
        }
    
        #tabs >>> .el-tabs__item {
            padding: 0 15px;
            height: 42px;
        }

        #tabs >>>.el-tabs__header .el-tabs__item {
            padding-top: 0;
            font: normal normal 500 15px/39px Noto Sans KR;
        }

        #tabs >>> .el-tabs__header .el-tabs__item.is-active {
            font: normal normal 18px/39px Noto Sans KR-BOLD;
        }

        .footer {
            padding-top: 6vh;
        }

    }

    @media all and (max-width: 940px) {

        #box {
            width: 54vw;
        }

        .box2 {
            margin-top: 0.5vh;
        }

        .checkBox1 {
            padding-top: 1.5vh;
            padding-bottom: 1vh;
            margin-right: 0.5vw;
        }
        .checkBox2 {
            padding-top: 1.5vh;
            padding-bottom: 1vh;

        }
        .checkBox3 {
            padding-top: 1.5vh;
            padding-bottom: 1vh;
            margin-right: 0.5vw;
        }
        .checkBox4 {
            padding-top: 1.5vh;
            padding-bottom: 1vh;

        }

        .el-row >>> .el-button {
            /* font: normal normal 19px/40px Noto Sans KR-BOLD */
            padding-top: 35%;
        }
        
    }

    /* 모바일 모드 */
    @media all and (max-width: 781px) {

        .mobileTabs {
            display: block;
        }

        .box {
            display: none;
        }

        #tabs {
            display: none;
        }

        /* .el-row >>> .el-button {
            padding: 13% 10vw 13% 10vw;
        } */

        .full {
            width: 100vw;
            margin: 0;
            /* height: fit-content; */
            display: inline-block;
        }

        .section {
            margin: 0;
        }

        .text {
            width: 100vw;
            font: normal normal 500 20px/29px Noto Sans KR;
            letter-spacing: 0px;
            color: #191C1D;
            display: inline-block;
            margin: 2% 0 1% 0 !important;
        }

        p {
            width: 100vw;
        }
        
        .mainSection {
            margin-top: 5%;
            width: 100vw;
            height: fit-content;
        }

        /* tab */
        .mobileTabs {
            margin-left: 11vw;
            
        }

        .tabTable1 >>>  .el-table__header-wrapper {
            display: none;
        }

        .tabTable1 {
            width: 79vw !important;
            font: normal normal 300 15px/11px Noto Sans KR;
            letter-spacing: 0px;
            color: #4C4C4C;
        }

        .tabTable2 >>> .el-table__header-wrapper {
            display: none;
        }

        .tabTable2 {
            width: 79vw !important;
            font: normal normal 300 15px/21px Noto Sans KR;
            letter-spacing: 0px;
            color: #4C4C4C;
        }

        .tabTable1 >>> .el-table__body-wrapper {
            font: normal normal 300 15px/21px Noto Sans KR;
        }

        .tabTable2 >>> .el-table__body-wrapper {
            font: normal normal 300 15px/21px Noto Sans KR;
        }

        .noticeBtn {
            padding: 0;
            margin: 0;
            padding-bottom: 2%;
            border-bottom: 3px solid #008FD2 !important; 
            border-radius: 0;
            font: normal normal 500 15px/21px Noto Sans KR;
            letter-spacing: 0px;
            color: #191C1D;
            padding-top: 5%;
            margin-left: 3%;
        }

        .eachBtn {
            padding: 0;
            margin: 0;
            padding-bottom: 2%;
            font: normal normal 500 15px/21px Noto Sans KR;
            letter-spacing: 0px;
            color: #191C1D;
            padding-top: 5%;
            margin-left: 3%;
        }

        .eachBtn.active {
            border-bottom: 3px solid #008FD2 !important; 
            border-radius: 0;
        }

        .tabLine1 {
            padding: 0;
            margin: 0;
            width: 95%;
            margin-left: 3%;
            border: 0.5px solid #707070;
        }

        .mobileTabs1 {
            width: 80vw;
            display: inline-block;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 10px;
            margin-bottom: 4vh;
            overflow: hidden;
        }

        .mobileTabs2 {
            width: 80vw;
            display: inline-block;
            background: #FFFFFF 0% 0% no-repeat padding-box;
            box-shadow: 0px 3px 6px #00000029;
            border-radius: 10px;
            margin-bottom: 2vh;
            overflow: hidden;
        }

        .more {
            margin-left: 34vw;
            font: normal normal 500 15px/21px Noto Sans KR;
        }

        .text {
            margin-bottom: 2vh !important;
        }

        .footer {
            padding-top: 8vh;
        }

    }

    @media all and (max-width: 489px) {

        .text {
            margin-bottom: 3vh !important;
        }

    }

    @media all and (max-width: 360px){

        .full {
            width: 100vw;
            margin: 0;
        }

        .text {
            width: 100vw;
            padding: 0;
            font: normal normal 500 20px/29px Noto Sans KR;
            display: inline-block;
            margin: 10vh 0 3% 0 !important;
        }

        p {
            width: 100vw;
        }

        #box {
            margin-left: -8%;
            padding-bottom: 3%;
            float: none;
        }

        .mainSection {
            margin-top: -3%;
            width: 100vw;
            height: fit-content;
        }

        .el-row >>> .el-button {
            height: 100%;
            /* width: 40%; */
            padding: 30% 13% 30% 13%;
            text-align: center;
            font: normal normal 18px/23px Noto Sans KR-BOLD;
            letter-spacing: -0.7px;
            color: #FFFFFF;
            background-color: transparent;
            border-color: transparent;
        }

        .footer {
            padding-top: 2vh;
            margin-top: 6.3vh;
        }

    }

    /* 높이 반응형 css */

    @media all and (max-height: 870px) {

        .text {
            margin-bottom: 5vh !important;
        }

        .footer {
            padding-top: 4vh;
        }
        
    }

    /* 노트북 1536 * 864 */
    @media all and (max-height: 830px) {

        .text {
            margin-bottom: 4vh !important;
        }

        .el-row >>> .el-button {
            padding: 39% 13% 18% 13%;
        }

        #box {
            padding-bottom: 1vh;
        }

        .box2 {
            margin-top: 1%;
        }

        .footer {
            padding-top: 1vh;
            /* position: relative;
            bottom: 0; */
        }

        .mainSection {
            margin-top: 13%;
        }
        
    }

    @media all and (max-height: 745px){
        
        .mainSection {
            margin-top: 22vh;
        }

        #box {
            margin-top: 0;
            padding-bottom: 0 !important;
        }

        .checkBox1 {
            width: 47%;
            padding-top: 0;
            padding-bottom: 0;
        }
        .checkBox2 {
            width: 47%;
            padding-top: 0;
            padding-bottom: 0;
        }
        .checkBox3 {
            width: 47%;
            padding-top: 0;
            padding-bottom: 0;
        }
        .checkBox4 {
            width: 47%;
            padding-top: 0;
            padding-bottom: 0;
        }

        #tabs {
            margin-top: 0;
        }

        .box2 {
            margin-top: 1%;
        }

        .text {
            margin-top: 0 !important;
            margin-bottom: 1vh !important;
            font: normal normal 500 16px/29px Noto Sans KR;
        }

        .el-row >>> .el-button {
            padding: 39% 13% 18% 13%;
        }

        /* .footer {
            padding-top: 2vh;
        } */
        
    }
     


</style>